import { 
  SET_ALERT, SET_LOADING, FETCH_DATA_PENDING, FETCH_DATA_COMPLETE, FETCH_DATA_FAIL, LOGOUT, WEBSOCKET_CONNECTING, WEBSOCKET_CONNECTED, WEBSOCKET_AUTHORIZED,
  WEBSOCKET_DISCONNECTED, SET_DELETE_PROJECT_DIALOGUE_ID, SET_DELETE_SCHEDULE_DIALOGUE_ID, SET_EDIT_PROJECT_DIALOGUE_ID, SET_PUBLISH_SCHEDULE_DIALOGUE_ID,
  SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID, UPDATE_CLIENT, SET_PROFILE_DIALOGUE_SHOWING, SET_NEW_SCHEDULE_DIALOGUE_ID, SET_GANON_VISIBLE, SET_EDIT_CONTRACTORS_DIALOGUE_ID,
  SET_NEW_DAILY_REPORT_DIALOGUE_ID, SET_DELETE_DAILY_REPORT_DIALOGUE_ID, SET_EDIT_DAILY_REPORT_DIALOGUE_ID, SET_PRIVACY_POLICY_DIALOGUE_OPEN, SET_TERMS_OF_USE_DIALOGUE_OPEN,
  SET_FEEDBACK_DIALOGUE_OPEN, SET_IS_TOUCH_DEVICE, SET_ADMIN_DIALOGUE_OPEN, SET_SITEBOARD_EMAIL_ADDRESS, SET_SCHEDULE_MESSAGES_DIALOGUE_ID, SET_UNREAD_MESSAGES_DIALOGUE_OPEN,
  SET_APP_FOCUSED, SET_WELCOME_DIALOGUE_OPEN, SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN, SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN,
  SET_USER_ROLE_INFO_DIALOGUE_SHOWING, SET_USING_INVITE_LINK, STOP_USING_INVITE_LINK, SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID, SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING,
  SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, STOP_USING_INVITE_SCHEDULE_CONTACT_LINK, SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK, STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK,
  SET_DELETE_CONTACT_DIALOGUE_OPEN, SET_PROJECT_CONTACTS_DIALOGUE_ID, SET_SHARE_LINK_DIALOGUE_SHOWING, SET_USING_SHARE_SCHEDULE_LINK, SET_EDIT_SCHEDULE_DIALOGUE_SHOWING,
  SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, SET_SHARE_SCHEDULE_CONFIRMED, SET_DELETE_PROMO_CODE_DIALOGUE_OPEN,
  SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN, SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN, PUSH_BROWSER_HISTORY_STATE, POP_BROWSER_HISTORY_STATE,
  SET_NOTE_PROMO_CODE_DIALOGUE_OPEN, SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, SET_USING_PROMO_SIGNUP_LINK, STOP_USING_PROMO_SIGNUP_LINK,
  SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING, SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING, SET_NEW_PROJECT_DIALOGUE_SHOWING,
} from '../actions/types';

const initialState = {
  loadingMessage: '',
  alertMessage: '',
  websocketState: WEBSOCKET_DISCONNECTED,
  pendingDataRequests: {},
  completedDataRequests: {},
  newClientVersion: null,
  deleteProjectDialogueId: null,
  deleteScheduleDialogueId: null,
  editProjectDialogueId: null,
  editProjectDialogueTabName: null,
  publishScheduleDialogueId: null,
  unpublishScheduleDialogueId: null,
  profileDialogueShowing: false,
  newScheduleDialogueScheduleId: null,
  newScheduleDialogueProjectId: null,
  editContractorsDialogueId: null,
  newDailyReportDialogueId: null,
  editDailyReportDialogueId: null,
  deleteDailyReportDialogueId: null,
  scheduleMessagesDialogueProjectId: null,
  scheduleMessagesDialogueThreadId: null,
  editProjectMembersDialogueId: null,
  isPrivacyPolicyDialogueOpen: false,
  isTermsOfUseDialogueOpen: false,
  isTrialWelcomeDialogueOpen: false,
  isFeedbackDialogueOpen: false,
  isAdminDialogueOpen: false,
  isUnreadMessagesDialogueOpen: false,
  isUpgradeToStandardDialogueOpen: false,
  isSubscriptionChooserDialogueOpen: false,
  isEditSubscriptionManagersDialogueOpen: false,
  isUserRoleInfoDialogueShowing: false,
  isTouchDevice: false,
  ganonVisible: false,
  siteboardEmail: '',
  isAppFocused: true,
  isUsingInviteLink: false,
  inviteLinkCode: '',
  inviteLinkEmail: '',
  isUsingInviteSubscriptionContactLink: false,
  inviteSubscriptionContactLinkCode: '',
  inviteSubscriptionContactLinkEmail: '',
  justJoinedSubscriptionDialogueId: null,
  isUsingUnsubscribeSubscriptionContactLink: false,
  unsubscribeSubscriptionContactLinkCode: '',
  unsubscribeSubscriptionContactLinkEmail: '',
  deleteContactDialogueEmail: '',
  deleteContactDialogueProjectId: '',
  deleteContactDialogueOpen: '',
  projectContactsDialogueId: '',
  shareScheduleLinkDialogueOpen: false,
  shareScheduleLinkDialogueScheduleId: '',
  isUsingShareScheduleLink: false,
  shareScheduleCode: '',
  editScheduleDialogueOpen: false,
  editScheduleDialogueScheduleId: '',
  requestScheduleEmailUpdatesDialogueOpen: false,
  confirmWorkDatesDialogueOpen: false,
  confirmWorkDatesDialogueEmail: '',
  confirmWorkDatesDialogueFirstName: '',
  confirmWorkDatesDialogueLastName: '',
  confirmWorkDatesDialogueCompanyName: '',
  confirmWorkDatesDialogueShareScheduleCode: '',
  shareScheduleConfirmed: false,
  reviewSharedScheduleViewsDialogueOpen: false,
  reviewSharedScheduleViewsDialogueScheduleId: false,
  reviewSharedScheduleConfirmationsDialogueOpen: false,
  reviewSharedScheduleConfirmationsDialogueScheduleId: '',
  browserHistoryPopStateListenerAdded: false,
  browserHistoryStates: [],
  browserHistoryStackCounter: 0,
  browserHistoryJustPoppedStateId: null,
  deletePromoCodeDialogueOpen: false,
  deletePromoCodeDialoguePromoCodeId: '',
  setNotePromoCodeDialogueOpen: false,
  setNotePromoCodeDialoguePromoCodeId: '',
  setExpirationPromoCodeDialogueOpen: false,
  setExpirationPromoCodeDialoguePromoCodeId: '',
  isUsingPromoSignupLink: false,
  promoSignupLinkCode: '',
  scheduleUnlockedConfirmationShowing: false,
  schedulePublishedConfirmationShowing: false,
  newProjectDialogueIsShowing: false,
};

const reducer = (state = initialState, action) => {
  if (action.type === LOGOUT) {
    return {
      ...state,
      loadingMessage: '',
      alertMessage: '',
      pendingDataRequests: {},
      completedDataRequests: {},
    };
  } else if (action.type === SET_ALERT) {
    return { ...state, alertMessage: action.payload };
  } else if (action.type === SET_LOADING) {
    return { ...state, loadingMessage: action.payload.message };
  } else if (action.type === FETCH_DATA_PENDING) {
    if (typeof action.payload !== 'string' || action.payload.length === 0) return state;

    return {
      ...state,
      pendingDataRequests: { ...state.pendingDataRequests, [action.payload]: true },
    };
  } else if (action.type === FETCH_DATA_COMPLETE) {
    if (typeof action.payload !== 'string' || action.payload.length === 0) return state;

    const newPendingDataRequests = {...state.pendingDataRequests};
    delete newPendingDataRequests[action.payload];
    
    return {
      ...state,
      pendingDataRequests: newPendingDataRequests,
      completedDataRequests: {...state.completedDataRequests, [action.payload]: true},
    };
  } else if (action.type === FETCH_DATA_FAIL) {
    if (typeof action.payload !== 'string' || action.payload.length === 0) return state;

    const newPendingDataRequests = {...state.pendingDataRequests};
    delete newPendingDataRequests[action.payload];
    
    return {
      ...state,
      pendingDataRequests: newPendingDataRequests,
    };
  } else if (action.type === WEBSOCKET_CONNECTING) {
    return { ...state, websocketState: WEBSOCKET_CONNECTING };
  } else if (action.type === WEBSOCKET_CONNECTED) {
    return { ...state, websocketState: WEBSOCKET_CONNECTED };
  } else if (action.type === WEBSOCKET_AUTHORIZED) {
    return { ...state, websocketState: WEBSOCKET_AUTHORIZED };
  } else if (action.type === WEBSOCKET_DISCONNECTED) {
    return { ...state, websocketState: WEBSOCKET_DISCONNECTED };
  } else if (action.type === SET_DELETE_PROJECT_DIALOGUE_ID) {
    return { ...state, deleteProjectDialogueId: action.payload };
  } else if (action.type === SET_DELETE_SCHEDULE_DIALOGUE_ID) {
    return { ...state, deleteScheduleDialogueId: action.payload };
  } else if (action.type === SET_PUBLISH_SCHEDULE_DIALOGUE_ID) {
    return { ...state, publishScheduleDialogueId: action.payload };
  } else if (action.type === SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID) {
    return { ...state, unpublishScheduleDialogueId: action.payload };
  } else if (action.type === SET_EDIT_PROJECT_DIALOGUE_ID) {
    return { ...state, editProjectDialogueId: action.payload.projectId, editProjectDialogueTabName: action.payload.tabName };
  } else if (action.type === SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID) {
    return { ...state, editProjectMembersDialogueId: action.payload.projectId };
  } else if (action.type === SET_NEW_SCHEDULE_DIALOGUE_ID) {
    return { 
      ...state, 
      newScheduleDialogueProjectId: action.payload.projectId,
      newScheduleDialogueScheduleId: action.payload.scheduleId,
    };
  } else if (action.type === SET_PROFILE_DIALOGUE_SHOWING) {
    return { ...state, profileDialogueShowing: action.payload === true };
  } else if (action.type === UPDATE_CLIENT) {
    return { ...state, newClientVersion: action.payload };
  } else if (action.type === SET_GANON_VISIBLE) {
    return { ...state, ganonVisible: action.payload === true };
  } else if (action.type === SET_EDIT_CONTRACTORS_DIALOGUE_ID) {
    return { ...state, editContractorsDialogueId: action.payload };
  } else if (action.type === SET_NEW_DAILY_REPORT_DIALOGUE_ID) {
    return { ...state, newDailyReportDialogueId: action.payload };
  } else if (action.type === SET_DELETE_DAILY_REPORT_DIALOGUE_ID) {
    return { ...state, deleteDailyReportDialogueId: action.payload };
  } else if (action.type === SET_EDIT_DAILY_REPORT_DIALOGUE_ID) {
    return { ...state, editDailyReportDialogueId: action.payload.dailyReportId };
  } else if (action.type === SET_SCHEDULE_MESSAGES_DIALOGUE_ID) {
    return { ...state, scheduleMessagesDialogueProjectId: action.payload.projectId, scheduleMessagesDialogueThreadId: action.payload.scheduleMessageThreadId  };
  } else if (action.type === SET_PRIVACY_POLICY_DIALOGUE_OPEN) {
    return { ...state, isPrivacyPolicyDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_TERMS_OF_USE_DIALOGUE_OPEN) {
    return { ...state, isTermsOfUseDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_WELCOME_DIALOGUE_OPEN) {
    return { ...state, isTrialWelcomeDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_FEEDBACK_DIALOGUE_OPEN) {
    return { ...state, isFeedbackDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_ADMIN_DIALOGUE_OPEN) {
    return { ...state, isAdminDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_UNREAD_MESSAGES_DIALOGUE_OPEN) {
    return { ...state, isUnreadMessagesDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN) {
    return { ...state, isUpgradeToStandardDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN) {
    return { ...state, isEditSubscriptionManagersDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN) {
    return { ...state, isSubscriptionChooserDialogueOpen: action.payload.isOpen };
  } else if (action.type === SET_USER_ROLE_INFO_DIALOGUE_SHOWING) {
    return { ...state, isUserRoleInfoDialogueShowing: action.payload.isOpen };
  } else if (action.type === SET_IS_TOUCH_DEVICE) {
    return { ...state, isTouchDevice: action.payload.isTouchDevice };
  } else if (action.type === SET_SITEBOARD_EMAIL_ADDRESS) {
    return { ...state, siteboardEmail: action.payload.email };
  } else if (action.type === SET_APP_FOCUSED) {
    return { ...state, isAppFocused: action.payload.isFocused };
  } else if (action.type === SET_USING_INVITE_LINK) {
    return { ...state, isUsingInviteLink: true, inviteLinkCode: action.payload.inviteCode, inviteLinkEmail: action.payload.inviteEmail };
  } else if (action.type === STOP_USING_INVITE_LINK) {
    return { ...state, isUsingInviteLink: false, inviteLinkCode: '', inviteLinkEmail: '' };
  } else if (action.type === SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK) {
    return { ...state, isUsingInviteSubscriptionContactLink: true, inviteSubscriptionContactLinkCode: action.payload.inviteCode, inviteSubscriptionContactLinkEmail: action.payload.inviteEmail };
  } else if (action.type === STOP_USING_INVITE_SCHEDULE_CONTACT_LINK) {
    return { ...state, isUsingInviteSubscriptionContactLink: false, inviteSubscriptionContactLinkCode: '', inviteSubscriptionContactLinkEmail: '' };
  } else if (action.type === SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK) {
    return { 
      ...state,
      isUsingUnsubscribeSubscriptionContactLink: true,
      unsubscribeSubscriptionContactLinkCode: action.payload.unsubscribeCode,
      unsubscribeSubscriptionContactLinkEmail: action.payload.unsubscribeEmail,
    };
  } else if (action.type === STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK) {
    return { ...state, isUsingUnsubscribeSubscriptionContactLink: false, unsubscribeSubscriptionContactLinkCode: '', unsubscribeSubscriptionContactLinkEmail: '' };
  } else if (action.type === SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING) {
    return { ...state, justJoinedSubscriptionDialogueId: action.payload.subscriptionId };
  } else if (action.type === SET_DELETE_CONTACT_DIALOGUE_OPEN) {
    return { 
      ...state, 
      deleteContactDialogueOpen: action.payload.isOpen,
      deleteContactDialogueProjectId: action.payload.projectId,
      deleteContactDialogueEmail: action.payload.email,
    };
  } else if (action.type === SET_PROJECT_CONTACTS_DIALOGUE_ID) {
    return { 
      ...state, 
      projectContactsDialogueId: action.payload.projectId,
    };
  } else if (action.type === SET_SHARE_LINK_DIALOGUE_SHOWING) {
    return { 
      ...state, 
      shareScheduleLinkDialogueOpen: action.payload.isOpen,
      shareScheduleLinkDialogueScheduleId: action.payload.scheduleId,
    };
  } else if (action.type === SET_USING_SHARE_SCHEDULE_LINK) {
    return {
      ...state,
      shareScheduleCode: action.payload.shareCode,
      isUsingShareScheduleLink: true,
    };
  } else if (action.type === SET_EDIT_SCHEDULE_DIALOGUE_SHOWING) {
    return {
      ...state,
      editScheduleDialogueOpen: action.payload.isOpen,
      editScheduleDialogueScheduleId: action.payload.scheduleId,
    };
  } else if (action.type === SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN) {
    return {
      ...state,
      requestScheduleEmailUpdatesDialogueOpen: action.payload.isOpen,
    };
  } else if (action.type === SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN) {
    return {
      ...state,
      confirmWorkDatesDialogueOpen: action.payload.isOpen,
      confirmWorkDatesDialogueEmail: action.payload.email,
      confirmWorkDatesDialogueFirstName: action.payload.firstName,
      confirmWorkDatesDialogueLastName: action.payload.lastName,
      confirmWorkDatesDialogueCompanyName: action.payload.companyName,
      confirmWorkDatesDialogueShareScheduleCode: action.payload.shareCode,
    };
  } else if (action.type === SET_SHARE_SCHEDULE_CONFIRMED) {
    return {
      ...state,
      shareScheduleConfirmed: action.payload.isConfirmed,
    };
  } else if (action.type === SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN) {
    return {
      ...state,
      reviewSharedScheduleViewsDialogueOpen: action.payload.isOpen,
      reviewSharedScheduleViewsDialogueScheduleId: action.payload.scheduleId,
    };
  } else if (action.type === SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN) {
    return {
      ...state,
      reviewSharedScheduleConfirmationsDialogueOpen: action.payload.isOpen,
      reviewSharedScheduleConfirmationsDialogueScheduleId: action.payload.scheduleId,
    };
  } else if (action.type === SET_DELETE_PROMO_CODE_DIALOGUE_OPEN) {
    return {
      ...state,
      deletePromoCodeDialogueOpen: action.payload.isOpen,
      deletePromoCodeDialoguePromoCodeId: action.payload.promoCodeId,
    };
  } else if(action.type === PUSH_BROWSER_HISTORY_STATE) {
    return {
      ...state,
      browserHistoryStates: [...state.browserHistoryStates, action.payload],
      browserHistoryStackCounter: state.browserHistoryStackCounter + 1,
      browserHistoryPopStateListenerAdded: true,
    };
  } else if(action.type === POP_BROWSER_HISTORY_STATE) {
    return {
      ...state,
      browserHistoryStates: [...state.browserHistoryStates.slice(0, -1)],
      browserHistoryStackCounter: state.browserHistoryStackCounter - 1,
      browserHistoryJustPoppedStateId: state.browserHistoryStates.length > 0 ? state.browserHistoryStates[state.browserHistoryStates.length-1].id : null,
    };
  } else if (action.type === SET_NOTE_PROMO_CODE_DIALOGUE_OPEN) {
    return {
      ...state,
      setNotePromoCodeDialogueOpen: action.payload.isOpen,
      setNotePromoCodeDialoguePromoCodeId: action.payload.promoCodeId,
    };
  } else if (action.type === SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN) {
    return {
      ...state,
      setExpirationPromoCodeDialogueOpen: action.payload.isOpen,
      setExpirationPromoCodeDialoguePromoCodeId: action.payload.promoCodeId,
    };
  } else if (action.type === SET_USING_PROMO_SIGNUP_LINK) {
    return {
      ...state,
      isUsingPromoSignupLink: true,
      promoSignupLinkCode: action.payload.promoCode,
    };
  } else if (action.type === STOP_USING_PROMO_SIGNUP_LINK) {
    return {
      ...state,
      isUsingPromoSignupLink: false,
      promoSignupLinkCode: '',
    };
  } else if (action.type === SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING) {
    return {
      ...state,
      scheduleUnlockedConfirmationShowing: action.payload.isOpen,
    };
  } else if (action.type === SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING) {
    return {
      ...state,
      schedulePublishedConfirmationShowing: action.payload.isOpen,
    };
  } else if (action.type === SET_NEW_PROJECT_DIALOGUE_SHOWING) {
    return {
      ...state,
      newProjectDialogueIsShowing: action.payload.isOpen,
    };
  }

  // default
  return state;
};

export default reducer;
